import { render, staticRenderFns } from "./worker-form.vue?vue&type=template&id=c888b78a&scoped=true&"
import script from "./worker-form.vue?vue&type=script&lang=js&"
export * from "./worker-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888b78a",
  null
  
)

export default component.exports